const adminMenuCheck = (currentUser, myPhotoModProfile) => {
    const moderatorId = myPhotoModProfile?.moderatorId;
    const isSuperuser = currentUser?.isSuperuser;
    const showAdmin = !!(moderatorId || isSuperuser);
    return showAdmin;
};

const getFirstActiveTeam = currentUser => {
    return currentUser?.ownedTeams?.find(t => t.hasActiveSubscription) || null;
};

const creatorToolsCheck = ({
    isIconCreator,
    isPhotoCreator,
    allowedToUploadIcons = true,
    allowedToUploadPhotos = true
}) => {
    // NOTE: isCreator on currentUser object is deprecated - please use `isIconCreator || isPhotoCreator`
    const isCreator = isIconCreator || isPhotoCreator;

    return {
        showMenu: isCreator,
        showIcons: allowedToUploadIcons && isIconCreator,
        showPhotos: allowedToUploadPhotos && isPhotoCreator
    };
};

/**
 * In Tablet/Desktop view we show a wider DropDown if there are 3 columns
 * We always show 1st column (Account) both admin and creator need
 * to be true for 3 columns and wider DropDown
 */
const menuHasThreeColumnsCheck = (showAdmin, creatorTools) => {
    return showAdmin && creatorTools.showMenu;
};

const getAuthMenuVisibility = (currentUser = {}, myPhotoModProfile) => {
    const firstActiveTeam = getFirstActiveTeam(currentUser);
    const showAdmin = adminMenuCheck(currentUser, myPhotoModProfile);
    const creatorTools = creatorToolsCheck(currentUser);
    return {
        firstActiveTeam,
        showAdmin,
        creatorTools,
        menuHasThreeColumns: menuHasThreeColumnsCheck(showAdmin, creatorTools)
    };
};

export default getAuthMenuVisibility;
